// extracted by mini-css-extract-plugin
export default {"backDrop":"ConsentModal_backDrop__FXokY","consentWrapper":"ConsentModal_consentWrapper__KBNJP","fullScreenContentWrapper":"ConsentModal_fullScreenContentWrapper__7LeaG"};